export default tabsSearchResults => {
    
    const tabs = tabsSearchResults.querySelector('.tabs');
    const tabsBtn = tabs.querySelectorAll('button');
    const resultContainer = tabsSearchResults.querySelector('.result-container');
    const mobileCardContainer = tabsSearchResults.querySelector('.mobile-card-container');
    const parts = resultContainer.querySelectorAll('.pane');

    function activeBtn(selectedTabBtn) {
        for (const tabBtn of tabsBtn) {
            tabBtn.classList.remove('active');
        }
        selectedTabBtn.classList.add('active');
    }

    function showPart(partName) {
        for (const part of parts) {
            part.classList.add('hide');
            if (part.getAttribute('id') === `pane-${partName}`) {
                part.classList.remove('hide');
            }
        }
        // Hide mobileCardContainer when switching to List pane
        if (partName === 'list') {
            mobileCardContainer.style.display = 'none';
        } else {
            mobileCardContainer.style.display = 'block';
        }
    }

    
    //window.onresize = getWW;
    function getWindowWidth(){
        let ww = window.innerWidth;
        return ww;
    }
    
    resizeMap();
    window.onresize = resizeMap;
    function resizeMap(){
        let ww = getWindowWidth();
        let paneMapHidden = resultContainer.querySelector('#pane-map').classList.contains('hide');
        
        if( ww >= 768 || paneMapHidden){
            mobileCardContainer.style.display = 'none';
        } else {
            mobileCardContainer.style.display = 'block';
        }
    }

    for (const tabBtn of tabsBtn) {
        tabBtn.addEventListener('click', event => {
            const dataPart = event.target.getAttribute('data-part');

            activeBtn(tabBtn);
            showPart(dataPart);
            
            if(dataPart == 'map'){
                var event = new CustomEvent('mapreload', {
                    detail: {}
                });
                document.getElementById('pane-map').dispatchEvent(event);
            }
        });
    }
};
